import { Component, OnInit, input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import {
  IonContent, IonHeader, IonTitle, IonToolbar, IonButtons, IonBackButton,
  IonCard, IonItem, IonLabel, IonIcon, IonToggle, IonAlert,
} from '@ionic/angular/standalone';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/api.service';
import { StorageService } from 'src/app/storage.service';
import { SubtitleDirective } from 'src/app/directives/subtitle.directive';
import { addIcons } from 'ionicons';
import { arrowForward, languageOutline } from 'ionicons/icons';
import { LANG_KEY } from 'src/app/app.component';
import { environment } from 'src/environments/environment';

export const VIEW_KEY = "_view_";

export interface IStateUserInfo {
  name: string,
  surname: string,
  second_surname: string,
  sex_id: string,
  birth_date: string,
  contact_id: string,
  age: number,
  contact_methods: Array<{
    contact_method_data: any,
    contact_method_name: string,
    contact_method_type: string,
    personal: number
  }>
}


@Component({
  selector: 'app-user',
  templateUrl: './user.page.html',
  styleUrls: ['./user.page.scss'],
  standalone: true,
  imports: [
    IonContent, IonHeader, IonTitle, IonToolbar, CommonModule, FormsModule,
    IonButtons, IonBackButton, SubtitleDirective, TranslateModule,
    IonCard, IonItem, IonLabel, IonIcon, IonToggle, IonAlert
  ]
})
export class UserPage implements OnInit {

  info = input.required<IStateUserInfo>();
  company = input.required<{ id: string, name: string }>();
  prl = input.required<boolean>();
  fac = input.required<boolean>();
  langinputs: { label: string, value: string, type: string }[] = []
  view: string = '';

  get fullName() {
    const uif = this.info();
    if (!uif) return '';
    return `${uif.name} ${uif.surname} ${uif.second_surname}`;
  }

  get currentLang() {
    return this.translate.currentLang;
  }

  get companyName() {
    const cmp = this.company();
    return cmp.name;
  }


  constructor(
    private translate: TranslateService,
    private api: ApiService,
    private storage: StorageService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    addIcons({
      user: 'assets/icon/user.svg',
      notis: 'assets/icon/notis.svg',
      location: 'assets/icon/location.svg',
      logout: 'assets/icon/logout.svg',
      admin: 'assets/icon/admin.svg',
      worker: 'assets/icon/worker.svg',
      lang: languageOutline,
      fwd: arrowForward
    });
    this._setLangCodes();
  }

  ngOnInit() {
    console.log(this.info());
    console.log(this.company());
  }

  async ionViewWillEnter() {
    try {
      // Carregar la vista desada
      const view = await this.storage.ready.then(() => this.storage.getCache(VIEW_KEY, 0));
      if (view) {
        this.view = view;
      }
    } catch (err) {
      console.error(err);
    }
  }

  disconnect() {
    this.router.navigateByUrl('/select-company');
  }

  logout() {
    this.api.logout().pipe(
      this.api.uify()
    ).subscribe({
      complete: () => {
        console.log('logged out!');
        this.router.navigateByUrl('/login');
      }
    })
  }

  setView(view: 'admin' | 'worker' | 'facs') {
    const cmp = this.company();
    this.storage.setCache(VIEW_KEY, view);
    // const route =
    //   view === 'admin'
    //     ? `/${cmp.id}/tabs/indicadors`
    //     : `/${cmp.id}/dashboard`;
    this.router.navigate([`/${cmp.id}/dashboard`]);
  }

  setLang(lang?: string) {
    if (!lang) return;
    this.translate.use(lang);
    this._setLangCodes();
    this.storage.set(LANG_KEY, lang);
    const uplangs: { [k: string]: string } = {
      ca: "CAT",
      es: "ESP",
      en: "ENG"
    }
    this.api.updateUserLanguage(uplangs[lang]).pipe(
      this.api.uify()
    ).subscribe({
      error: (err) => this.debug(err, 'setting language upstream'),
      complete: () => {
        this.debug('update language complete');
        this.storage.clearCache();
      }
    });

  }

  private _setLangCodes() {
    const langs = this.translate.getLangs();
    const langNames = this.translate.instant(langs.map(l => `perfil.${l}`));
    const curlang = this.translate.currentLang;
    this.langinputs = langs.map(lng => {
      return { label: langNames[`perfil.${lng}`], value: lng, type: 'radio', checked: curlang == lng }
    })
  }

  editProfile() {
    //const userInfo = this.info();
    this.router.navigate(['editar'], {
      relativeTo: this.route,
      state: { isEditingProfile: true },
    });
  }

  debug(sth: any, tag = "") {
    if (environment.production) return;
    console.log(`DEBUG ${this.constructor.name} ${tag}`, sth);
  }

}
